import React, { useCallback } from 'react';
import { Modal } from './index';
import { useModalSearchParam } from '@/shared/hooks/useModalSearchParam';

interface ModalWithSearchParamProps {
  paramName: string;
  children: React.ReactNode;
  className?: string;
  showCloseButton?: boolean;
  isFullscreen?: boolean;
  maxWidth?: string;
  onOpen?: () => void;
  onClose?: (hasUnsavedChanges?: boolean) => void;
}

export const ModalWithSearchParam: React.FC<ModalWithSearchParamProps> = ({
  paramName,
  children,
  onOpen,
  onClose,
  ...modalProps
}) => {
  const { isOpen, close } = useModalSearchParam({
    paramName,
    onOpen,
  });

  const handleClose = useCallback((hasChanges?: boolean) => {
    if (onClose) {
      onClose(hasChanges);
    }

    // Закрываем модальное окно только если явно передано false
    if (hasChanges === false) {
      close();
    }
  }, [close, onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        // При первом клике на закрытие всегда делегируем в форму
        handleClose(undefined);
      }}
      {...modalProps}
    >
      {children}
    </Modal>
  );
};
